 const brands = [
    {
      name : "goldland logo",
      logo : "/images/brand_carousel/goldland.svg",
    },

    {
      name : "parotext logo",
      logo : "/images/brand_carousel/paro_foundation.svg",
    },

    {
      name : "ovision logo",
      logo : "/images/brand_carousel/Ovisione.svg",
    },

    {
      name : "scent redesign logo",
      logo : "/images/brand_carousel/scent_art_print.svg",
    },

    {
      name : "SD logo",
      logo : "/images/brand_carousel/SD-Onaiwi.svg",
    },
    
    {
      name : "uchenna Nnaji logo",
      logo : "/images/brand_carousel/Uche_nnaji_redesign.svg",
    }
  
  ];

export default brands;